export const MENU_SELECTED = "MENU_SELECTED";
export const USER_GROUP_SELECTED = "USER_GROUP_SELECTED";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const GROUPS_LOADED = "GROUPS_LOADED";
export const LOGOUT = "LOGOUT";
export const CHANGE_TAB = "CHANGE_TAB";
export const SETTINGS_LOADED = "SETTINGS_LOADED";
export const SETTINGS_UPDATED = "SETTINGS_UPDATED";
export const FETCHING_MULTIPLE_USERS = "FETCHING_MULTIPLE_USERS";
export const LOADED_MULTIPLE_USERS = "LOADED_MULTIPLE_USERS";
export const FETCH_MULTIPLE_USERS_FAILED = "FETCH_MULTIPLE_USERS_FAILED";
export const RESTAURANTS_LOADED = "RESTAURANTS_LOADED";
export const NO_RESTAURANTS_ADDED = "NO_RESTAURANTS_ADDED";
export const CLOSE_UPLOAD_MENU_MODAL = "CLOSE_UPLOAD_MENU_MODAL";
export const RESTAURANTS_LOADING = "RESTAURANTS_LOADING";
export const UPDATE_RESTAURANT_SUCCESS = "UPDATE_RESTAURANT_SUCCESS";
export const UPDATE_RESTAURANT_ERROR = "UPDATE_RESTAURANT_ERROR";
export const CREATE_RESTAURANT_ERROR = "CREATE_RESTAURANT_ERROR";
export const CREATE_RESTAURANT_SUCCESS = "CREATE_RESTAURANT_SUCCESS";
export const TOGGLE_CREATE_MENU = "TOGGLE_CREATE_MENU";
export const TOGGLE_UPDATE_MENU = "TOGGLE_UPDATE_MENU";
export const PUBLISH_MENU_SUCCESS = "PUBLISH_MENU_SUCCESS";
export const CREATE_MENU_SUCCESS = "CREATE_MENU_SUCCESS";
export const DELETE_MENU_SUCCESS = "DELETE_MENU_SUCCESS";
export const RESTAURANTS_LOADED_ERROR = "RESTAURANTS_LOADED_ERROR";
export const RESET_USER_GROUP_SELECTED = "RESET_USER_GROUP_SELECTED";
export const CREATE_NEW_USER_SUCCESS = "CREATE_NEW_USER_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_NEW_USER_SUCCESS";
export const MENUS_LOADED = "MENUS_LOADED";
export const MENUS_LOADED_ERROR = "MENUS_LOADED_ERROR";
export const GET_MENU_DETAIL = "GET_MENU_DETAIL";
export const UPDATE_OLD_MENU = "UPDATE_OLD_MENU";
export const MENUS_SORTED = "MENUS_SORTED";
export const SAVE_USER_ERROR = "SAVE_USER_ERROR";
export const CREATE_ACCOUNT_INFORMATION = "CREATE_ACCOUNT_INFORMATION";
export const ADD_USER_TO_GROUP_SUCCESS = "ADD_USER_TO_GROUP_SUCCESS";
export const PLANS_LOADED = "PLANS_LOADED";
export const PLANS_LOADED_ERROR = "PLANS_LOADED_ERROR";
export const SELECTED_PLAN = "SELECTED_PLAN";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
